/* Raadhamart premium theme layer (rm-theme.js) — vanilla JS, no dependencies.
   Does: sticky-header shadow, mobile drawer, search toggle, scroll reveal,
   gallery thumbnails + hover zoom, quantity stepper, sticky mobile Add to Cart,
   AJAX add-to-cart with loading state and live cart count.
   Cart/checkout logic stays Shopify's own (/cart/add.js, /cart.js, /checkout). */
(function () {
  'use strict';
  var doc = document;
  doc.documentElement.classList.add('rm-js');

  /* Sticky header shadow */
  var header = doc.querySelector('.rm-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile drawer */
  var drawer = doc.getElementById('rm-drawer'), scrim = doc.querySelector('.rm-scrim');
  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open); scrim.classList.toggle('is-open', open);
    var b = doc.querySelector('.rm-burger'); if (b) b.setAttribute('aria-expanded', String(open));
    if (open) { var f = drawer.querySelector('a,button'); f && f.focus(); }
  }
  doc.addEventListener('click', function (e) {
    if (e.target.closest('.rm-burger')) toggleDrawer(true);
    else if (e.target.closest('.rm-drawer-close') || e.target === scrim) toggleDrawer(false);
    var st = e.target.closest('.rm-search-toggle');
    if (st) { var ms = doc.querySelector('.rm-mobile-search'); var o = ms.classList.toggle('is-open'); st.setAttribute('aria-expanded', String(o)); if (o) ms.querySelector('input').focus(); }
  });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggleDrawer(false); });

  /* Scroll reveal */
  var items = doc.querySelectorAll('.rm-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  } else { items.forEach(function (el) { el.classList.add('is-in'); }); }

  /* Gallery: thumbnails + hover zoom origin */
  var main = doc.querySelector('.rm-gallery__main img');
  doc.querySelectorAll('.rm-thumbs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!main) return;
      main.src = btn.dataset.full; if (btn.dataset.srcset) main.srcset = btn.dataset.srcset;
      doc.querySelectorAll('.rm-thumbs button').forEach(function (b) { b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  });
  var gm = doc.querySelector('.rm-gallery__main');
  if (gm) gm.addEventListener('mousemove', function (e) {
    var r = gm.getBoundingClientRect();
    gm.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
    gm.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
  });

  /* Quantity stepper */
  doc.querySelectorAll('.rm-qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]'); if (!b) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10)); input.value = v;
    });
  });

  /* Cart count */
  function setCount(n) {
    doc.querySelectorAll('.rm-cart-count').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  refreshCount();

  /* AJAX add to cart (falls back to normal form post if anything fails) */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-rm-atc]'); if (!form || !window.fetch) return;
    if (e.submitter && e.submitter.name === 'return_to') return; /* Buy it now: normal POST, Shopify redirects to checkout */
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'), live = doc.querySelector('.rm-live');
    btn.classList.add('is-loading'); btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { refreshCount(); if (live) live.textContent = 'Added to cart'; btn.classList.remove('is-loading'); btn.disabled = false; })
      .catch(function () { form.removeAttribute('data-rm-atc'); form.submit(); });
  });

  /* Sticky mobile Add to Cart: show once main button leaves viewport */
  var sticky = doc.querySelector('.rm-sticky-atc'), anchor = doc.querySelector('[data-rm-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(anchor);
  }
})();
